<!-- Modern Mobile Header 2025 -->
<div class="modern-mobile-header">
    <div class="header-surface" [class.is-scrolling]="isHeaderScrolled" [class.is-active]="isHeaderActive">
        <div class="header-main">
            <div class="header-leading">
                @if (showBackArrow()) {
                <button class="header-btn back-btn" type="button" (click)="backMenu()" aria-label="Go back">
                    <lucide-icon name="arrow-left" size="20"></lucide-icon>
                </button>
                } @else {
                <a
                    class="brand-container"
                    [class.compact]="isHeaderScrolled"
                    routerLink="/dashboard"
                    aria-label="OwnRewards home"
                >
                    <img
                        class="brand-mark-icon"
                        src="/images/logo.png"
                        width="36"
                        height="36"
                        alt=""
                        decoding="async"
                    />
                </a>
                }
            </div>

            <div class="header-center">
                <h1 class="header-title">{{ getActiveMenuTitle() }}</h1>
            </div>

            <div class="header-trailing">
                <div class="header-actions">
                    @if (planLoaded) {
                    <a routerLink="/billing" class="mobile-plan-chip" [class.mobile-plan-chip--trial]="planIsTrial"
                        [attr.aria-label]="planIsTrial && planDaysLeft !== null
                          ? planLabel + ', ' + planDaysLeft + ' days left. ' + planCta
                          : planLabel + '. ' + planCta">
                        @if (planDaysLeft !== null) {
                        <span class="mobile-plan-chip__days">{{ planDaysLeft }}d</span>
                        } @else {
                        <span class="mobile-plan-chip__days">{{ planLabel.split(' ')[0] }}</span>
                        }
                        <span class="mobile-plan-chip__cta">{{ planCta }}</span>
                    </a>
                    }

                    <!-- Search icon: always visible -->
                    <button class="header-search-btn" type="button" (click)="showModal()" aria-label="Search">
                        <lucide-icon name="search" size="18" class="header-search-btn__icon"></lucide-icon>
                    </button>

                    @if (!isPageHeaderFixed || !isHeaderScrolled || showBackArrow()) {
                    <button
                        type="button"
                        class="profile-trigger"
                        (click)="openAccountSheet()"
                        aria-label="Account menu"
                        [attr.aria-expanded]="accountSheetOpen"
                        aria-haspopup="dialog"
                    >
                        <div class="profile-avatar" [class.compact]="isHeaderScrolled">
                            <div class="avatar-gradient">
                                <lucide-icon name="user-circle" size="22" class="avatar-lucide-icon"></lucide-icon>
                            </div>
                            <div class="status-dot"></div>
                        </div>
                    </button>
                    }
                </div>
            </div>
        </div>
    </div>

    <or-sheet
        [open]="accountSheetOpen"
        title="Account"
        subtitle="Switch outlet or manage your session"
        (closed)="closeAccountSheet()"
    >
        <div class="account-sheet">
            <section class="account-sheet__identity" aria-label="Signed-in user">
                <div class="account-sheet__avatar" aria-hidden="true">
                    <lucide-icon name="user-circle" size="28"></lucide-icon>
                </div>
                <div class="account-sheet__who">
                    <strong>{{ displayName }}</strong>
                    @if (userName?.email) {
                    <span>{{ userName.email }}</span>
                    }
                </div>
            </section>

            <section class="account-sheet__outlets" aria-label="Outlets">
                <div class="account-sheet__section-head">
                    <h3>
                        <lucide-icon name="store" size="16" aria-hidden="true"></lucide-icon>
                        Working at
                    </h3>
                    <span class="account-sheet__count">{{ outletTotalCount || allOutlet.length }}</span>
                </div>

                <div class="account-sheet__outlet-list" (scroll)="onOutletListScroll($event)">
                    @if (outletsLoading) {
                    <div class="account-sheet__loading">
                        <nz-spin nzSimple nzSize="small"></nz-spin>
                    </div>
                    } @else {
                    @if (currentOutlet) {
                    <p class="account-sheet__label">Current outlet</p>
                    <button
                        type="button"
                        class="account-outlet account-outlet--active"
                        (click)="onAccountOutletPick(currentOutlet)"
                    >
                        <span class="account-outlet__radio" aria-hidden="true"></span>
                        <span class="account-outlet__copy">
                            <span class="account-outlet__name">{{ currentOutlet.outletName }}</span>
                            <span
                                class="account-outlet__badge"
                                [class.account-outlet__badge--inactive]="!currentOutlet.isActive"
                            >
                                {{ currentOutlet.isActive ? 'Active' : 'Inactive' }}
                            </span>
                        </span>
                    </button>
                    }
                    @if (otherOutlets.length) {
                    <p class="account-sheet__label" [class.account-sheet__label--spaced]="currentOutlet">
                        Other outlets
                    </p>
                    @for (item of otherOutlets; track item._id) {
                    <button type="button" class="account-outlet" (click)="onAccountOutletPick(item)">
                        <span class="account-outlet__radio" aria-hidden="true"></span>
                        <span class="account-outlet__copy">
                            <span class="account-outlet__name">{{ item.outletName }}</span>
                            <span
                                class="account-outlet__badge"
                                [class.account-outlet__badge--inactive]="!item.isActive"
                            >
                                {{ item.isActive ? 'Active' : 'Inactive' }}
                            </span>
                        </span>
                    </button>
                    }
                    }
                    @if (!currentOutlet && !otherOutlets.length) {
                    <p class="account-sheet__empty">No outlets available</p>
                    }
                    @if (outletLoadingMore) {
                    <div class="account-sheet__loading account-sheet__loading--more">
                        <nz-spin nzSimple nzSize="small"></nz-spin>
                    </div>
                    }
                    }
                </div>
            </section>

            <button type="button" class="account-sheet__link" (click)="goToSettings()">
                <lucide-icon name="settings" size="18" aria-hidden="true"></lucide-icon>
                <span>Settings</span>
                <lucide-icon name="chevron-right" size="16" aria-hidden="true"></lucide-icon>
            </button>
        </div>

        <div sheetFooter>
            <button type="button" class="or-btn or-btn--ghost account-sheet__logout" (click)="logOut()">
                <lucide-icon name="log-out" size="18" aria-hidden="true"></lucide-icon>
                Log out
            </button>
        </div>
    </or-sheet>


    <nz-dropdown-menu #moreMenu="nzDropdownMenu">
        <ul nz-menu class="mobile-dropdown-menu">
            <li nz-menu-item>
                <lucide-icon name="download" size="14"></lucide-icon>
                <span>Export Data</span>
            </li>
            <li nz-menu-item>
                <lucide-icon name="printer" size="14"></lucide-icon>
                <span>Print</span>
            </li>
            <li nz-menu-item>
                <lucide-icon name="share-2" size="14"></lucide-icon>
                <span>Share</span>
            </li>
        </ul>
    </nz-dropdown-menu>
</div>

<!-- Enhanced Search Modal -->
<nz-modal [(nzVisible)]="isVisible" [nzClosable]="false" (nzOnCancel)="handleCancel()" [nzFooter]="null"
    [nzBodyStyle]="{ padding: '0' }" [nzWidth]="'100vw'"
    nzWrapClassName="mobile-search-modal-wrap">
    <ng-container *nzModalContent>
        <!-- Drag handle -->
        <div class="mobile-search-drag-handle"></div>

        <div class="mobile-search-header">
            <!-- Title + type tabs row -->
            <div class="mobile-search-header__top">
                <div class="mobile-search-header__title">
                    <lucide-icon name="search" size="16" class="mobile-search-header__title-icon"></lucide-icon>
                    <span>Quick Search</span>
                </div>
                <div class="mobile-search-type-tabs">
                    <button type="button" class="mobile-search-type-tab"
                        [class.active]="searchType === 'pages'"
                        (click)="changeSearchType('pages')">
                        <lucide-icon name="layout" size="13"></lucide-icon>
                        <span>Pages</span>
                    </button>
                    <button type="button" class="mobile-search-type-tab"
                        [class.active]="searchType === 'members'"
                        (click)="changeSearchType('members')">
                        <lucide-icon name="users" size="13"></lucide-icon>
                        <span>Members</span>
                    </button>
                </div>
            </div>

            <!-- Search input -->
            <div class="mobile-search-input-wrap">
                <nz-input-group [nzPrefix]="prefixIconTpl1" class="mobile-search-input-group">
                    <ng-template #prefixIconTpl1>
                        <lucide-icon name="search" size="15" class="mobile-search-prefix-icon"></lucide-icon>
                    </ng-template>
                    <input autocomplete="off" #searchInput type="search" nz-input
                        [placeholder]="searchType === 'pages' ? 'Search pages...' : 'Search phone number...'"
                        [(ngModel)]="searchText"
                        (ngModelChange)="onSearchTextChange()"
                        (keydown)="onSearchInputKeydown($event)" />
                </nz-input-group>
            </div>
        </div>

        <div class="mobile-search-content">
            @if (searchType === 'pages') {
                <div class="mobile-search-results search-results-container" #searchResultsContainer
                    [class.keyboard-nav]="isKeyboardSearchNav"
                    (mousemove)="onSearchResultsPointerInteraction()">
                    @for (section of filteredSideMenuForSearch; track section.label) {
                        <p class="mobile-search-section-label">{{ section.label }}</p>
                        @for (item of section.items; track item.path) {
                        <div class="mobile-search-result-item search-result-item"
                            [class.active]="isSearchResultActive(getPageItemIndex(item))"
                            [routerLink]="item.path" (click)="modalclose()">
                            <div class="mobile-search-item-icon">
                                @if (item.icon) {
                                <lucide-icon [name]="item.icon" size="20" class="mobile-search-item-lucide"></lucide-icon>
                                }
                            </div>
                            <div class="mobile-search-item-content">
                                <span class="mobile-search-item-name">{{ item?.name }}</span>
                                <span class="mobile-search-item-path">{{ item?.path }}</span>
                            </div>
                            <lucide-icon name="arrow-right" size="16" class="mobile-search-item-arrow"></lucide-icon>
                        </div>
                        }
                    }
                    @if (searchText.trim().length > 0 && hasNoResults()) {
                    <div class="mobile-search-empty">
                        <lucide-icon name="file-search" size="36" class="mobile-search-empty__icon"></lucide-icon>
                        <p class="mobile-search-empty__text">No results for "{{ searchText }}"</p>
                        <p class="mobile-search-empty__hint">Try a different page name</p>
                    </div>
                    }
                </div>
            } @else {
                @if (searchText.trim().length === 0) {
                <div class="mobile-search-empty">
                    <lucide-icon name="users" size="36" class="mobile-search-empty__icon"></lucide-icon>
                    <p class="mobile-search-empty__text">Search for a member</p>
                    <p class="mobile-search-empty__hint">Enter name or phone number</p>
                </div>
                } @else if (membersLoading) {
                <div class="mobile-search-loading">
                    <nz-spin nzSimple></nz-spin>
                    <span>Searching members...</span>
                </div>
                } @else {
                <div class="mobile-search-results search-results-container" #searchResultsContainer
                    [class.keyboard-nav]="isKeyboardSearchNav"
                    (mousemove)="onSearchResultsPointerInteraction()">
                    @for (member of filteredMembers; track member._id; let i = $index) {
                    <div class="mobile-search-result-item search-result-item"
                        [class.active]="isSearchResultActive(i)"
                        (click)="goToMemberDetail(member)">
                        <div class="mobile-search-item-icon">
                            <lucide-icon name="user" size="20" class="mobile-search-item-lucide"></lucide-icon>
                        </div>
                        <div class="mobile-search-item-content">
                            <span class="mobile-search-item-name">{{ member.name || 'Unnamed Member' }}</span>
                            <span class="mobile-search-item-path">{{ member.phoneNo || 'No Phone Number' }}</span>
                        </div>
                        <lucide-icon name="arrow-right" size="16" class="mobile-search-item-arrow"></lucide-icon>
                    </div>
                    }
                    @if (hasNoResults()) {
                    <div class="mobile-search-empty">
                        <lucide-icon name="file-search" size="36" class="mobile-search-empty__icon"></lucide-icon>
                        <p class="mobile-search-empty__text">No members found</p>
                        <p class="mobile-search-empty__hint">Try a different name or phone number</p>
                    </div>
                    }
                </div>
                }
            }
        </div>
    </ng-container>
</nz-modal>
